module.exports = __webpack_public_path__ + "static/media/guage.2ed9755b.png";